import { BaseEntity } from "./BaseEntity";
import { Company } from "./Company";

export class CompanyDocument extends BaseEntity {
    public name: string = "";
    public attachmentName: string = "";
    public company: string | Company = "";

    constructor(model: Partial<CompanyDocument> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PCompanyDocument = Partial<CompanyDocument>;
